import * as React from 'react';


type ProgressLoaderProps = {
    position: string
    style: React.CSSProperties
}

function ProgressLoader({ position, style }: ProgressLoaderProps) {
    const wrapperClasses = 'progress-loader';

    return <div
        className={`${wrapperClasses} ${position}`}
        style={style} />;
}

export default ProgressLoader;